import { render, staticRenderFns } from "./SurveyRevisions.vue?vue&type=template&id=ec13d1b0&"
import script from "./SurveyRevisions.vue?vue&type=script&lang=js&"
export * from "./SurveyRevisions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports